export default __webpack_public_path__ + "static/media/ImportGuide.5b300f52.pdf";